export default "__VITE_ASSET__CXphizgL__"